import {css} from "lit";

export const annotationBookmarkStyles = css`
	pn-rte {
		display: block;
		margin-bottom: 6px;
	}
`;
